import { createRouter, createWebHistory } from "vue-router";

import middlewarePipeline from './middleware/middlewarePipeline'
import guest from "./middleware/guest";
import ApplicantRouting from "./applicant/routing";
import EmployeeRouting from "./employee/routing";
import AdminRouting from "./admin/routing";
import store from "../store";

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Home",
  },
  {
    path: "/login/:status?",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Registration.vue"),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/verify/email",
    name: "VerifyEmail",
    component: () => import(/* webpackChunkName: "register" */ "../views/VerifyEmail.vue"),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import(/* webpackChunkName: "ForgotPassword" */ "../views/ForgotPassword.vue"),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: () => import(/* webpackChunkName: "ResetPassword" */ "../views/ResetPassword.vue"),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/403",
    name: "403",
    component: () => import(/* webpackChunkName: "login" */ "../views/403.vue"),
  },

  {
    path: "/signers",
    name: "Signers",
    component: () => import(/* webpackChunkName: "Signers" */ "../views/Signers.vue"),
  },

  ...ApplicantRouting,
  ...EmployeeRouting,
  ...AdminRouting,
  { path: "/:catchAll(.*)", redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {

  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store,
  }

  return middleware[0]({
    ...context,
    nextMiddleware: middlewarePipeline(context, middleware, 1)
  })

})

export default router;
